export const chip = {
    aria: {
        closeLabel: 'Close',
    },
};
//# sourceMappingURL=chip.js.map